<mat-card appearance="outlined" class="change-set">
  <mat-card-content>
    <mat-accordion>
      @for (change of changes; track change; let i = $index) {
        <mat-expansion-panel [attr.data-testid]="'change-set-list'">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ change.commandClass }}
            </mat-panel-title>
            <mat-panel-description>
              <div class="panel-description">
                {{ change.description }}
              </div>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <br/>
          <emm-change
            [featureScope]="featureScope"
            [lastChange]="lastChange"
            [change]="change"
          ></emm-change>
        </mat-expansion-panel>
      }
    </mat-accordion>
    @if (changeCount > pageSize) {
      <mat-paginator
        #paginator
        [length]="changeCount"
        [pageSize]="pageSize"
        (page)="page($event)"
        showFirstLastButtons
      ></mat-paginator>
    }
  </mat-card-content>
</mat-card>
